import { render, staticRenderFns } from "./MixerItem.vue?vue&type=template&id=13bf5ff8&scoped=true&"
import script from "./MixerItem.vue?vue&type=script&lang=js&"
export * from "./MixerItem.vue?vue&type=script&lang=js&"
import style0 from "./MixerItem.vue?vue&type=style&index=0&id=13bf5ff8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bf5ff8",
  null
  
)

export default component.exports